import ReviewRentalDetailsContainer from './ReviewRentalDetailsContainer';

export default ReviewRentalDetailsContainer;
